import { appRoutes, AppRoute } from '@components';
import { isGranted } from '@lib';
import { useStore } from '@stores';
import { Badge, Menu, Space } from 'antd';
import { observer } from 'mobx-react';
import { useLocation, useNavigate } from 'react-router-dom';

declare const abp: any;

interface ISiderMenuProps {
  onItemClick?: () => void;
}

export const SiderMenu = observer(({ onItemClick }: ISiderMenuProps = {}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { sessionStore } = useStore();

  const generateMenuItems = (routes: AppRoute[]) =>
    routes
      .filter((route) => !(route.path === '/calendar' && abp.session.impersonatorUserId !== null))
      .filter((route) => route.showInMenu && (!route.permission || isGranted(route.permission)))
      .map((route) => {
        const item: any = {
          key: route.path,
          icon:
            route.path === '/chat' ? (
              <Space size="middle">
                <Badge size="small" count={sessionStore.unreadCount}>
                  {route.icon}
                </Badge>
              </Space>
            ) : (
              route.icon
            ),
          label: route.title,
          onClick: () => {
            if (!route.children && route.path) {
              navigate(route.path);
              onItemClick?.();
            }
          },
        };

        if (route.children) {
          item.children = generateMenuItems(route.children);
        }

        return item;
      });

  return (
    <Menu
      theme="light"
      mode="inline"
      style={{ border: 'none' }}
      selectedKeys={[pathname]}
      items={generateMenuItems(appRoutes)}
    />
  );
});
